import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ErrorMessage from './ErrorMessage';
import { normalizePortalText } from 'utils/baochauTheme';
import useFormControl from './useFormControl';
import './style.scss';

const FormTextArea = ({
  field,
  validation,
  placeholder,
  disabled,
  readOnly,
  className,
  style,
  rows,
  onChange,
  id,
  'aria-describedby': ariaDescribedBy,
}) => {
  const { describedBy, error, errorId, fieldValue, hasError, inputId, setFieldValue } = useFormControl({
    field,
    validation,
    id,
    ariaDescribedBy,
  });

  return (
    <React.Fragment>
      <textarea
        id={inputId}
        style={style}
        rows={rows}
        className={classNames('bw_form_control bw_form_textarea', className, {
          'is-invalid': hasError,
          'is-readonly': readOnly,
        })}
        disabled={disabled}
        readOnly={readOnly}
        aria-invalid={hasError || undefined}
        aria-describedby={describedBy}
        name={field}
        data-field={field}
        placeholder={typeof placeholder === 'string' ? normalizePortalText(placeholder) : placeholder}
        value={fieldValue ?? ''}
        onChange={(e) => {
          setFieldValue(e.target.value);
          onChange && onChange(e);
        }}
      />
      {error && <ErrorMessage id={errorId} message={error?.message} />}
    </React.Fragment>
  );
};

FormTextArea.propTypes = {
  field: PropTypes.string,
  validation: PropTypes.object,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  id: PropTypes.string,
};

export default FormTextArea;
